module.exports = __webpack_public_path__ + "img/bg-christmas.3009312b.svg";